import * as React from "react";
import { useState, useCallback, useMemo } from "react";
import ExpandedEntitiesSectionsContext from "./ExpandedSectionsContext";
const ExpandedSectionsProvider = ({ children }) => {
  const [expandedSections, setExpandedSections] = useState();
  const toggleSection = useCallback(
    (entityId, sectionName) => setExpandedSections((cur) => {
      var _a, _b;
      const newCur = { ...cur != null ? cur : {} };
      if ((_a = newCur[entityId]) == null ? void 0 : _a.includes(sectionName)) {
        const newSections = newCur[entityId].filter((section) => section !== sectionName);
        if (newSections.length === 0) {
          delete newCur[entityId];
          return newCur;
        }
        return { ...newCur, [entityId]: newSections };
      }
      return { ...newCur, [entityId]: [...(_b = newCur[entityId]) != null ? _b : [], sectionName] };
    }),
    []
  );
  const contextValue = useMemo(
    () => ({
      expandedSections,
      toggleSection
    }),
    [expandedSections, toggleSection]
  );
  return /* @__PURE__ */ React.createElement(ExpandedEntitiesSectionsContext.Provider, { value: contextValue }, children);
};
export default ExpandedSectionsProvider;
